import { render, staticRenderFns } from "./pictureBoxes.vue?vue&type=template&id=340cebd0"
import script from "./pictureBoxes.vue?vue&type=script&lang=js"
export * from "./pictureBoxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports